export default __webpack_public_path__ + "static/media/ua.41f78cec.svg";